import * as React from 'react'
import styles from './index.module.css'

/**
 * Empty state message component with icon, header, and call-to-action
 * Used to display placeholder content when lists or containers are empty
 * @param icon - Icon or visual element to display
 * @param header - Header text or content for the empty state
 * @param cta - Call-to-action content or button for user interaction
 */
export default class EmptyMessage extends React.PureComponent<{
  icon: React.ReactNode
  header: React.ReactNode
  cta: React.ReactNode
}> {
  render(): React.ReactElement<'div'> {
    return (
      <div className={styles.emptyMessageEmptyCont}>
        <div className={styles.emptyMessageEmptyIcon}>{this.props.icon}</div>
        <div className={styles.emptyMessageEmptyHeader}>
          {this.props.header}
        </div>
        <div className={styles.emptyMessageEmptyDesc}>{this.props.cta}</div>
      </div>
    )
  }
}
